import LoadingManager from '../../../FE/src/assets/javascripts/utils/LoadingManager.js';

export default class ResourceDirectory {
  constructor(el) {
    this.$el = $(el);
    this.$grid = this.$el.find('.gg-resource-directory__grid');
    this.$content = this.$el.find('.gg-resource-directory__content');
    this.$empty = this.$el.find('.gg-resource-directory__empty');
    this.$clearFiltersBtn = this.$el.find('.gg-filter-controls__clear-btn');

    // Filter controls
    this.$typeFilter = this.$el.find('.gg-resource-directory__filter-type');
    this.$topicFilter = this.$el.find('.gg-resource-directory__filter-topic');
    this.$sortControl = this.$el.find('.gg-resource-directory__sort');

    // AJAX settings
    this.ajaxUrl = this.$el.data('ajax-url');
    this.allowedCategories = this.$el.data('allowed-categories') || '';

    // Current state
    this.currentCategory = this.getUrlParameter('category') || '';
    this.defaultPrimaryGroup = this.$el.data('default-primary-group') || '';
    this.currentPrimaryCategory = this.$el.data('primary-group')
      || this.getUrlParameter('primary_group')
      || this.defaultPrimaryGroup;
    this.includeUngrouped = parseInt(this.$el.data('include-ungrouped') || 0, 10);
    this.currentResourceType = this.getUrlParameter('resource_type') || '';
    this.currentTopic = this.getUrlParameter('topic') || '';
    this.currentSort = this.getUrlParameter('sort') || '';
    // eslint-disable-next-line radix
    this.currentPage = parseInt(this.getUrlParameter('page')) || 1;

    this.isLoading = false;
    this.needsRefreshAfterFilterNormalization = false;
  }

  init() {
    this.bindEvents();
    this.updateFilterOptionsFromCurrentResults();
  }

  bindEvents() {
    // Listen for category change from gravity-filter-tabs
    $(document).on('filterTabsChanged', (_e, category, postType, allowedCategories) => {
      // Only handle if it's for resources
      if (postType === 'resource') {
        this.currentCategory = category;
        this.currentPrimaryCategory = this.getUrlParameter('primary_group') || '';
        this.includeUngrouped = (this.currentPrimaryCategory === this.defaultPrimaryGroup) ? 1 : 0;
        // Reset to page 1 when category changes
        this.currentPage = 1;
        this.setUrlParameter('category', category);
        this.setUrlParameter('page', '');
        // Update allowed categories if passed from filter tabs
        if (allowedCategories !== undefined) {
          this.allowedCategories = allowedCategories;
        }
        this.refreshResources();
      }
    });

    // Listen for filter changes
    $(document).on('resourceTypeChanged', (_e, value) => {
      this.currentResourceType = value;
      // Reset to page 1 when filter changes
      this.currentPage = 1;
      this.setUrlParameter('resource_type', value);
      this.setUrlParameter('page', '');
      this.refreshResources();
    });

    $(document).on('resourceTopicChanged', (_e, value) => {
      this.currentTopic = value;
      // Reset to page 1 when filter changes
      this.currentPage = 1;
      this.setUrlParameter('topic', value);
      this.setUrlParameter('page', '');
      this.refreshResources();
    });

    $(document).on('resourceSortChanged', (_e, value) => {
      this.currentSort = value;
      // Reset to page 1 when sort changes
      this.currentPage = 1;
      this.setUrlParameter('sort', value);
      this.setUrlParameter('page', '');
      this.refreshResources();
    });

    // Clear filters
    this.$clearFiltersBtn.on('click', () => this.handleClearFilters());

    // Pagination clicks - delegate to handle dynamically loaded pagination
    this.$el.on('click', '.pagination a', (e) => {
      e.preventDefault();
      const $link = $(e.currentTarget);
      // Don't do anything if disabled
      if ($link.hasClass('disabled')) {
        return;
      }

      // Extract page number from URL
      const href = $link.attr('href');
      const urlParams = new URLSearchParams(href.split('?')[1] || '');
      // eslint-disable-next-line radix
      const page = parseInt(urlParams.get('page')) || 1;

      if (page && page !== this.currentPage) {
        this.currentPage = page;
        this.setUrlParameter('page', page);
        this.refreshResources();
        this.scrollToTop();
      }
    });
  }

  // Clear all filters
  handleClearFilters() {
    this.currentResourceType = '';
    this.currentTopic = '';
    this.currentSort = '';
    // Reset to page 1 when clearing filters
    this.currentPage = 1;

    // Reset dropdowns
    if (this.$typeFilter.data('ggSelect')) {
      this.$typeFilter.data('ggSelect').reset();
    }
    if (this.$topicFilter.data('ggSelect')) {
      this.$topicFilter.data('ggSelect').reset();
    }
    if (this.$sortControl.data('ggSelect')) {
      this.$sortControl.data('ggSelect').reset();
    }

    // Update URL
    this.setUrlParameter('resource_type', '');
    this.setUrlParameter('topic', '');
    this.setUrlParameter('sort', '');
    this.setUrlParameter('page', '');

    // Refresh
    this.refreshResources();
  }

  // Refresh resources via AJAX
  refreshResources() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    LoadingManager.show();

    // Update clear button state
    const hasFilters = this.currentResourceType || this.currentTopic || this.currentSort;
    this.$clearFiltersBtn.prop('disabled', !hasFilters);

    $.ajax({
      url: this.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'load_resources',
        category: this.currentCategory,
        // eslint-disable-next-line camelcase
        primary_group: this.currentPrimaryCategory,
        // eslint-disable-next-line camelcase
        include_ungrouped: this.includeUngrouped,
        // eslint-disable-next-line camelcase
        resource_type: this.currentResourceType,
        topic: this.currentTopic,
        sort: this.currentSort,
        page: this.currentPage,
        // eslint-disable-next-line camelcase
        allowed_categories: this.allowedCategories,
      },
      success: (response) => {
        if (response.success && response.data) {
          this.applyFilterAvailability(response.data);
        }

        if (response.success && response.data.html) {
          // Has results
          this.$grid.html(response.data.html);
          this.$content.removeClass('hidden');
          this.$empty.addClass('hidden');
          // Update pagination HTML from server
          const $paginationWrapper = this.$el.find('.gg-resource-directory__pagination-wrapper');
          if (response.data.pagination_html) {
            $paginationWrapper.html(response.data.pagination_html);
          } else {
            $paginationWrapper.empty();
          }
        } else {
          // No results
          this.$grid.html('');
          this.$content.addClass('hidden');
          this.$empty.removeClass('hidden');
          this.$el.find('.gg-resource-directory__pagination-wrapper').empty();
        }
      },
      error: (error) => {
        console.error('Error loading resources:', error);
      },
      complete: () => {
        this.isLoading = false;
        LoadingManager.hide();

        if (this.needsRefreshAfterFilterNormalization) {
          this.needsRefreshAfterFilterNormalization = false;
          this.currentPage = 1;
          this.setUrlParameter('page', '');
          this.refreshResources();
        }
      },
    });
  }

  updateFilterOptionsFromCurrentResults() {
    const typeOptions = this.$typeFilter.find('.gg-select__option:visible').map((_index, el) => {
      const value = String($(el).data('value') || '');
      return value;
    }).get().filter((value) => value !== '');

    const topicOptions = this.$topicFilter.find('.gg-select__option:visible').map((_index, el) => {
      const value = String($(el).data('value') || '');
      return value;
    }).get().filter((value) => value !== '');

    this.toggleFilterOptions(this.$typeFilter, typeOptions, 'type');
    this.toggleFilterOptions(this.$topicFilter, topicOptions, 'topic');
  }

  applyFilterAvailability(data) {
    const typeOptions = Array.isArray(data.available_resource_types)
      ? data.available_resource_types
      : [];
    const topicOptions = Array.isArray(data.available_topics)
      ? data.available_topics
      : [];

    const hasTypeReset = this.toggleFilterOptions(this.$typeFilter, typeOptions, 'type');
    const hasTopicReset = this.toggleFilterOptions(this.$topicFilter, topicOptions, 'topic');

    if (hasTypeReset || hasTopicReset) {
      this.needsRefreshAfterFilterNormalization = true;
    }
  }

  toggleFilterOptions($filter, allowedValues, filterType) {
    if (!$filter.length) {
      return false;
    }

    const allowedSet = new Set((allowedValues || []).map((value) => String(value)));

    $filter.find('.gg-select__option').each((_index, el) => {
      const $option = $(el);
      const value = String($option.data('value') || '');
      const shouldShow = value === '' || allowedSet.has(value);
      $option.toggle(shouldShow);
    });

    const button = $filter.find('.gg-select__button');
    button.prop('disabled', allowedSet.size === 0);

    let wasReset = false;

    if (filterType === 'type') {
      if (this.currentResourceType && !allowedSet.has(this.currentResourceType)) {
        this.currentResourceType = '';
        this.setUrlParameter('resource_type', '');
        this.resetFilterDropdownUI($filter);
        wasReset = true;
      }
    } else if (filterType === 'topic') {
      if (this.currentTopic && !allowedSet.has(this.currentTopic)) {
        this.currentTopic = '';
        this.setUrlParameter('topic', '');
        this.resetFilterDropdownUI($filter);
        wasReset = true;
      }
    }

    return wasReset;
  }

  resetFilterDropdownUI($filter) {
    const $options = $filter.find('.gg-select__option');
    $options.removeClass('active');
    const $allOption = $options.filter('[data-value=""]').first();
    if ($allOption.length) {
      $allOption.addClass('active');
    }
    $filter.find('.gg-select__value').text('');
    $filter.removeClass('selected');
  }

  // Scroll to top of resources
  scrollToTop() {
    const offset = this.$el.offset().top - 100;
    $('html, body').animate({ scrollTop: offset }, 400);
  }

  // URL parameter helpers
  getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || '';
  }

  setUrlParameter(name, value) {
    const urlParams = new URLSearchParams(window.location.search);

    if (value === '' || !value) {
      urlParams.delete(name);
    } else {
      urlParams.set(name, value);
    }

    const queryString = urlParams.toString();
    const newUrl = queryString
      ? `${window.location.pathname}?${queryString}`
      : window.location.pathname;
    window.history.pushState({}, '', newUrl);
  }
}

// Initialize on page load
if (typeof window.acf === 'undefined') {
  $(document).ready(() => {
    $('.gg-resource-directory').each((_index, el) => {
      new ResourceDirectory(el).init();
    });
  });
} else {
  // eslint-disable-next-line
  acf.addAction(
    'render_block_preview/type=acf/gravity-resource-directory',
    ($el) => {
      $el.find('.gg-resource-directory').each((_index, el) => {
        new ResourceDirectory(el).init();
      });
    },
  );
}
